import { toRoman } from '@/pages/onboarding/components/toRoman';

export interface OnboardingStepDefinition {
    slug: string;
    label: string;
    optional?: boolean;
}

interface OnboardingProgressSidebarProps {
    steps: OnboardingStepDefinition[];
    currentStepSlug: string;
    completedSlugs: string[];
    onStepClick?: (slug: string) => void;
}

export default function OnboardingProgressSidebar({
    steps,
    currentStepSlug,
    completedSlugs,
    onStepClick,
}: OnboardingProgressSidebarProps) {
    return (
        <aside className="ob-sidebar">
            <header className="ob-sidebar__brand">
                <div className="ob-sidebar__brand-mark">
                    Trigger<em>flow</em>
                </div>
                <div className="ob-sidebar__brand-sub">Concierge</div>
            </header>

            <p className="ob-sidebar__intro">
                « Quelques étapes pour configurer&nbsp;votre établissement, sans hâte. »
            </p>

            <div className="ob-sidebar__heading">Étapes</div>

            <ol className="ob-sidebar__list">
                {steps.map((step, index) => {
                    const isCompleted = completedSlugs.includes(step.slug);
                    const isCurrent = step.slug === currentStepSlug;
                    const status = isCompleted ? 'complete' : isCurrent ? 'current' : 'pending';
                    const clickable = isCompleted && !!onStepClick;

                    return (
                        <li key={step.slug} className="ob-sidebar__item">
                            <button
                                type="button"
                                disabled={!clickable}
                                data-clickable={clickable}
                                data-status={status}
                                onClick={() => clickable && onStepClick?.(step.slug)}
                                className="ob-sidebar__step"
                            >
                                <span className="ob-sidebar__numeral" aria-hidden>
                                    {isCompleted ? '✓' : toRoman(index + 1)}
                                </span>
                                <span className="ob-sidebar__step-label">
                                    {step.label}
                                    {step.optional && (
                                        <span className="ob-sidebar__optional">
                                            (optionnel)
                                        </span>
                                    )}
                                </span>
                            </button>
                        </li>
                    );
                })}
            </ol>

            <footer className="ob-sidebar__footer">
                <div className="ob-sidebar__footer-flourish">— Bienvenue</div>
                Une question pendant la configuration&nbsp;?
                Écrivez-nous, on est à&nbsp;l'écoute.
            </footer>
        </aside>
    );
}
